// @flow
import { connect } from 'react-redux';

import { fetchReportsRequest } from 'redux/Machine/actions';
import { reports } from 'redux/Machine/selectors';
import Reports, { type DispatchPropsType } from './Reports.component';

const mapStateToProps = (state: StoreType): DashboardStore => ({
  reports: reports(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  fetchReports: (payload) => dispatch(fetchReportsRequest(payload)),
});

export default (connect(mapStateToProps, mapDispatchToProps)(Reports): any);
